export default __webpack_public_path__ + "static/media/Greta2400.6cfca463.jpg";